var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star_border"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8337 5.68134L8.63949 5.31967L7.00033 1.45801L5.36116 5.32551L1.16699 5.68134L4.35199 8.44051L3.39533 12.5413L7.00033 10.3655L10.6053 12.5413L9.65449 8.44051L12.8337 5.68134ZM7.00033 9.27467L4.80699 10.5988L5.39033 8.10218L3.45366 6.42217L6.00866 6.20051L7.00033 3.84967L7.99783 6.20634L10.5528 6.42801L8.61616 8.10801L9.19949 10.6047L7.00033 9.27467Z",
    fill: "#FFE600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBorder);
export default __webpack_public_path__ + "static/media/star_border.46f9b3b897457b8dad19091d7cd88a79.svg";
export { ForwardRef as ReactComponent };